export const FrameworkController = {
    index(): void {},
};
